/** @format */

const isReferrerGoogle = (referrer: string) => {
	try {
		const url = new URL(referrer);
		const validHosts = ['google.com', 'www.google.com'];
		return validHosts.includes(url.hostname);
	} catch (e) {
		return false;
	}
};
export const plaCheck = (
	referrer: string | undefined,
	campParam: string | undefined,
	emailPLAParam: string | undefined
) =>
	(typeof referrer === 'string' && isReferrerGoogle(referrer)) ||
	(typeof campParam === 'string' && campParam.includes('CSE')) ||
	(typeof campParam === 'string' && campParam.includes('SEM')) ||
	(typeof campParam === 'string' && campParam.includes('SNS')) ||
	emailPLAParam === 'true';
